import { ConfigurationType } from './types/ConfigurationType';
import isDev from './utils/environmentDetector';

const config: ConfigurationType = {
    apiBaseUrl: isDev() ? process.env.REACT_APP_API_BASEURL ?? "http://localhost:5000" : "{API_BASE_URL}",
    clientAuthority: isDev() ? process.env.REACT_APP_MSAL_CLIENT_AUTHORITY ?? "https://login.microsoftonline.com/b2eb8529-51f8-4d43-92bf-85201eea6023" : "{MSAL_CLIENT_AUTHORITY}",
    clientId: isDev() ? process.env.REACT_APP_MSAL_CLIENT_ID ?? "946e6a53-27ae-4584-91d6-75ea45f7e008" : "{MSAL_CLIENT_ID}",
    apiScope: isDev() ? process.env.REACT_APP_MSAL_CLIENT_API_SCOPE ?? "api://3c337853-b245-43a3-8b78-9a0f4a2bf5c4/.default" : "{MSAL_CLIENT_API_SCOPE}",
    redirectUrl: isDev() ? process.env.REACT_APP_MSAL_CLIENT_REDIRECT_URL ?? "http://localhost:3000" : "{MSAL_CLIENT_REDIRECT_URL}"
}

export { config };